import React, { useState } from "react";
import Footer from "../components/Footer";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet-async";
import Navbar from "../components/Navbar";
import banner from "../assets/baner.webp";
import { Link } from "react-router-dom";

const Contacts = () => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const validate = () => {
    const { first_name, last_name, email, phone, message } = formData;

    if (!first_name || first_name.length < 2) {
      toast.error("First name must be at least 2 characters.");
      return false;
    }
    if (!last_name || last_name.length < 2) {
      toast.error("Last name must be at least 2 characters.");
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address.");
      return false;
    }
    const phoneRegex = /^[0-9]{10,15}$/;
    if (!phoneRegex.test(phone)) {
      toast.error("Phone number must be 10–15 digits.");
      return false;
    }
    if (!message || message.length < 10) {
      toast.error("Message must be at least 10 characters.");
      return false;
    }
    return true;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}api/inquiry`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        },
      );

      const data = await response.json();

      if (response.ok) {
        toast.success(data.data?.message || "Message sent successfully!");
        setFormData({
          first_name: "",
          last_name: "",
          email: "",
          phone: "",
          message: "",
        });
      } else {
        toast.error(data.message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Network error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Helmet>
        <title>Perfume Enquiry</title>
        <meta name="description" content="Welcome to Perfume Enquiry page" />
      </Helmet>
      <div className="bg-black">
        <Navbar />
      </div>
      {/* HERO SECTION */}
      <div className="bg-white w-full py-[1rem] px-[1rem] sm:px-[5rem] text-[16px] text-gray-500">
        <span className="text-gray-800">
          <Link to={"/"}>Home</Link>
        </span>{" "}
        {">"} Contact Us
      </div>
      <div
        className="relative h-[55vh] w-full flex items-center justify-center bg-cover bg-center"
        style={{ backgroundImage: `url(${banner})` }}
      >
        <div className="absolute inset-0 bg-black/60" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/50 to-black/70" />

        <div className="relative z-10 text-center px-4">
          <h1 className="text-white text-3xl sm:text-5xl md:text-6xl font-bold tracking-[0.25em] uppercase">
            Contact Us
          </h1>

          <p className="mt-4 text-gray-300 text-sm sm:text-base tracking-widest">
            Discover Your Signature Scent
          </p>

          <div className="mt-5 flex items-center justify-center gap-2">
            <span className="w-12 h-[1px] bg-white/60" />
            <span className="w-2 h-2 rounded-full bg-white/80" />
            <span className="w-12 h-[1px] bg-white/60" />
          </div>
        </div>
      </div>

      {/* CONTACT SECTION */}
      <div className="bg-white py-16 px-4 sm:px-8 md:px-16 lg:px-24">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch">
          {/* LEFT INFO PANEL */}
          <div className="flex flex-col justify-center">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
              Let’s Connect
            </h2>

            <p className="mt-5 text-gray-600 text-base sm:text-lg leading-relaxed">
              We’d love to hear from you. Whether it’s a question,
              collaboration, or feedback — our team is ready to help you
              experience fragrance at its finest.
            </p>

            <div className="mt-8 space-y-4 text-gray-700 text-sm sm:text-base">
              <p>📧 info@giftofgodfragrances.com</p>
              <p>📞 (848) 667-0850</p>
              <p>📍 New Jersey, USA</p>
            </div>
          </div>

          {/* RIGHT FORM CARD */}
          <div className="bg-white/80 backdrop-blur-xl border border-gray-200 shadow-xl rounded-2xl p-6 sm:p-8 md:p-10">
            <form className="space-y-5 font-outfit" onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <input
                  type="text"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  placeholder="First Name"
                  className="w-full p-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-black outline-none"
                  required
                />

                <input
                  type="text"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  placeholder="Last Name"
                  className="w-full p-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-black outline-none"
                  required
                />

                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email Address"
                  className="w-full p-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-black outline-none sm:col-span-2"
                  required
                />

                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Phone Number"
                  className="w-full p-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-black outline-none sm:col-span-2"
                  required
                />
              </div>

              <textarea
                name="message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                placeholder="Your Message..."
                className="w-full p-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-black outline-none"
                required
              />

              <p className="text-sm text-gray-500">
                We typically respond within 24–48 hours.
              </p>

              <button
                type="submit"
                className="w-full bg-black text-white py-3 rounded-xl hover:opacity-90 transition-all font-medium tracking-wide"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Contacts;
